import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useFilePreview } from '@/contexts/file-preview'
import { usePresignedGetUrl } from '@/hooks/usePresignedGetUrl'

export const CV_ATTACHMENT_FILE_PREFIX = 'cv'

// Custom hook for handling CV URL clicks with file preview support
export const useCvUrlClick = () => {
    const { t } = useTranslation()
    const { preview } = useFilePreview()
    const { getPresignedUrl, isGettingPresignedUrl } = usePresignedGetUrl()

    const handleCvUrlClick = useCallback(
        async (url: string, isFile: boolean, cvName?: string) => {
            if (!url) return

            try {
                if (isFile) {
                    // Get presigned URL for file access
                    const presignedUrl = await getPresignedUrl(url)

                    // Use file preview context
                    preview(
                        presignedUrl,
                        undefined,
                        {
                            attachment_file_name: cvName || 'CV File',
                            attachment_file_url: presignedUrl,
                            attachment_file_type: 'application/pdf',
                        },
                        true
                    )
                } else {
                    // For external URLs, open in new tab
                    window.open(url, '_blank', 'noopener,noreferrer')
                }
            } catch (error) {
                console.error('Failed to get presigned URL:', error)
            }
        },
        [getPresignedUrl, preview, t]
    )

    return {
        handleCvUrlClick,
        isGettingPresignedUrl,
    }
}

export const TYPES_OF_POSITION = [
    {
        label: 'Trainee',
        value: 'Trainee',
    },
    {
        label: 'Team Lead',
        value: 'Team Lead',
    },
    {
        label: 'Intern',
        value: 'Intern',
    },
    {
        label: 'Manager',
        value: 'Manager',
    },
    {
        label: 'Staff',
        value: 'Staff',
    },
    {
        label: 'Head',
        value: 'Head',
    },
]
export const DEPARTMENT = [
    {
        label: 'MKT',
        value: 'MKT',
    },
    {
        label: 'CS',
        value: 'CS',
    },
    {
        label: 'SALES',
        value: 'SALES',
    },
    {
        label: 'TECH',
        value: 'TECH',
    },
    {
        label: 'DEV',
        value: 'DEV',
    },
    {
        label: 'FINANCE',
        value: 'FINANCE',
    },
    {
        label: 'HR',
        value: 'HR',
    },
    {
        label: 'B.O.D',
        value: 'B.O.D',
    },
]
export const CV_SCREEN_RESULTS = [
    {
        label: 'PASS',
        value: 'PASS',
    },
    {
        label: 'FAIL',
        value: 'FAIL',
        mail_template: 'thank_you_letter',
    },
    {
        label: 'CLOSE JOB',
        value: 'CLOSE JOB',
        mail_template: 'close_job',
    },
]

export const FINAL_STATUS = [
    {
        label: 'Interview',
        value: 'Interview',
        mail_template: 'send_mail_interview',
        disable: true,
    },
    {
        label: 'Từ chối phỏng vấn',
        value: 'Từ chối phỏng vấn',
    },
    {
        label: 'Pass Interview',
        value: 'Pass Interview',
    },
    {
        label: 'Fail Interview',
        value: 'Fail Interview',
        mail_template: 'thank_talent',
    },
    {
        label: 'Đề xuất vị trí khác',
        value: 'Đề xuất vị trí khác',
    },
    {
        label: 'Tuyển dụng',
        value: 'Tuyển dụng',
    },
    {
        label: 'Từ chối Onboard',
        value: 'Từ chối Onboard',
    },
    {
        label: 'Fail Screen CV',
        value: 'Fail Screen CV',
        mail_template: 'thank_you_letter',
    },
    {
        label: 'Not open',
        value: 'Not open',
    },
]
